import { css } from '@/styled-system/css';

export const tabStyles = css.raw({
  textStyle: { base: 'body-xs', sm: 'body-sm', md: 'body' },
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  '&[aria-selected=“false”]': {
    justifyContent: 'center',
  },
  '&[aria-selected=“true”]': {
    justifyContent: 'center',
  },
});
